import {
  Accordion,
  AccordionItem,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useMemo } from "react";
import LeadsSummary from "./summary/LeadsSummary";
import { useReportingStore } from "../../../../stores/ReportingStore";
import LeadsSummaryMulti from "./summary/LeadsSummaryMulti";
import ReportingInfo from "../ReportingInfo";
import { useLanguage } from "../../../../stores/LanguageStore";

const ReportingLeads = () => {
  const lang = useLanguage((s) => s.language);
  const programmations = useReportingStore((s) => s.programmations);

  const component = useMemo(() => {
    if (programmations.length > 1) {
      return <LeadsSummaryMulti />;
    }
    return <LeadsSummary />;
  }, [programmations.length]);

  return (
    <Accordion variant="contained" radius={"md"} defaultValue={"activity"}>
      <AccordionItem value="activity" style={{ border: 0 }}>
        <Accordion.Control bg={"primary.0"}>
          <Group pr={32}>
            <Title order={3} fw={500} ff={"Inter"} mb={8} pos={"relative"}>
              <span style={{ fontSize: 24, marginRight: 8 }}>📊</span>{" "}
              {lang.reports.leads_summary}
            </Title>

            <ReportingInfo>
              <Text>{lang.reports.lead_classification_text}</Text>
            </ReportingInfo>

            {/* <Text ml={"auto"} size="lg">
              <NumberFormatter
                value={statistics.email_sent}
                style={{ fontWeight: 700 }}
              />{" "}
              {lang.reports.email_sent}{" "}
              <NumberFormatter
                value={statistics.linkedin_sent}
                style={{ fontWeight: 700 }}
              />{" "}
              {lang.reports.linkedin_actions}
            </Text> */}
          </Group>
        </Accordion.Control>

        <Accordion.Panel bg={"var(--mantine-color-primary-2)"}>
          <Stack align="center" pt={16}>
            {component}
          </Stack>
        </Accordion.Panel>
      </AccordionItem>
    </Accordion>
  );
};

export default ReportingLeads;
